import { WithStyles, withStyles } from '@core/theme/utils/with-styles';

import { styles } from './StoreTransactionCard.styles';

export interface StoreTransactionCardInterface extends WithStyles<typeof styles> {
  header: string;
  text: string;
  onClickHandler: () => void;
  image: React.ReactNode;
}

const StoreTransactionCardComponent: React.FC<StoreTransactionCardInterface> = ({
  classes,
  image,
  header,
  text,
  onClickHandler,
}) => {
  return (
    <div className={classes.cardWrap} onClick={onClickHandler}>
      <div className={classes.imageWrap}>{image}</div>
      <div>
        <p className={classes.header}>{header}</p>
        <p className={classes.text}>{text}</p>
      </div>
    </div>
  );
};

export const StoreTransactionCard = withStyles(styles)(StoreTransactionCardComponent);
